import axios from 'axios';
import { Service } from 'axios-middleware';
import refreshTokensIfNeeded from "@/logic/refreshTokensIfNeeded"

type AxiosRequestConfig = {
  adapter: () => any,
  data: any,
  env: {
    Blob: () => any,
    FormData: () => any,
  },
  headers: { [key: string]: string },
  maxBodyLength: number,
  maxContentLength: number,
  method: string,
  timeout: number,
  transformRequest: any,
  transformResponse: any,
  transitional: {
    clarifyTimeoutError: boolean,
    forcedJSONParsing: boolean,
    silentJSONParsing: boolean
  },
  url: string,
  validateStatus: () => any,
  xsrfCookieName: string,
  xsrfHeaderName: string,
}

const service = new Service(axios);

const onRequest = async (config: AxiosRequestConfig) => {
  // await refreshTokensIfNeeded(config.url, config.method)
  return config;
}

// const onSync = (promise: any) => {
//   console.log('onSync');
//   return promise;
// }

// const onResponse = async (response: any) => {
//   console.log('onResponse');
//   return response;
// }

service.register({
  onRequest,
  // onSync,
  // onResponse,
});